import React from 'react';
import { Button } from 'react-bootstrap';
import styles from './Button.module.scss';

type LearnMoreButtonProps = {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  children?: React.ReactNode;
};

const LearnMoreButton: React.FC<LearnMoreButtonProps> = ({ onClick, children }) => {
  return (
    <Button
      variant="primary"
      className={styles["learn-more"]}
      onClick={onClick}
    >
      {children || 'Saiba mais'}
    </Button>
  );
};

export default LearnMoreButton;
